<template>
  <div class="table-responsive">
    <table class="table table-xs font-size-xs" :id="dataTable.id">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.id">
            {{ column.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(customer, index) in customers" :key="index">
          <td v-for="column in columns" :key="column.id">
            <div v-if="column.id === 'select'">
              <div
                class="
                  custom-control custom-checkbox
                  mb-2
                  d-flex
                  align-items-center
                "
              >
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="
                    index + '_' + customer.codcfo + '_' + customer.codColigada
                  "
                  v-model="customers[index].isSelected"
                  @change="selectClient(index)"
                />
                <label
                  class="custom-control-label"
                  :for="
                    index + '_' + customer.codcfo + '_' + customer.codColigada
                  "
                ></label>
              </div>
            </div>
            <div v-else-if="column.id === 'type'">
              <select
                class="form-control mw-type"
                v-model="customers[index].customerType"
                :disabled="!customers[index].isSelected"
              >
                <option value="" disabled selected></option>
                <option
                  :value="ct.PS_TC_ID"
                  v-for="ct in customerTypes"
                  :key="ct.PS_TC_ID"
                >
                  {{ ct.PS_TC_NOME }}
                </option>
              </select>
            </div>
            <div v-else-if="column.id === 'classification'">
              <select
                class="form-control mw-classification"
                v-model="customers[index].classification"
                :disabled="!customers[index].isSelected"
              >
                <option value="" disabled selected></option>
                <option value="Titular" title="Titular">Titular</option>
                <option value="Suplente" title="Suplente">Suplente</option>
                <option value="Outros" title="Outros">Outros</option>
              </select>
            </div>
            <div v-else-if="column.id === 'lastReview'">
              {{
                customer.lastReview
                  ? dateTimeSqlToDateBR(customer.lastReview.date)
                  : ''
              }}
            </div>
            <div v-else>
              {{ customer[column.column] }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="card-footer d-flex justify-content-between">
      <div class="counter">
        <p>Clientes Selecionados: {{ numberOfSelectedCustomers }}</p>
      </div>
      <button class="ml-auto btn btn-success" @click="insertBatchCustomers">
        Cadastrar Selecionados
      </button>
    </div>
  </div>
</template>
<style scoped>
.mw-type {
  min-width: 143px !important;
}
.mw-classification {
  min-width: 110px !important;
}
</style>
<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import 'datatables.net-dt/js/dataTables.dataTables'
import '@/utils/basicDataTableExtend'
import { dateTimeSqlToDateBR } from '@/utils/date'

export default {
  name: 'DatatableSelectCustomers',

  components: {},

  props: {
    unityId: {
      type: Number,
      required: true,
    },
    periodId: {
      type: String,
      required: true,
    },
    customers: {
      type: Array,
      required: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    customerTypes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dateTimeSqlToDateBR,
      selectedCustomers: [],
      numberOfSelectedCustomers: 0,
      dataTable: {
        id: 'dataTableListCustomers',
        columnDefs: [
          {
            orderable: false,
            width: 130,
            targets: [5],
          },
        ],
      },
    }
  },

  computed: {},
  watch: {
    customers: {
      handler(newVal, oldVal) {
        const selected = this.customers.filter(
          (customer) => customer.isSelected,
        )
        this.numberOfSelectedCustomers = selected.length
      },
    },
  },
  methods: {
    selectClient(index) {
      if (!this.customers[index].isSelected) {
        delete this.customers[index].customerType
        delete this.customers[index].classification
      }
      this.countSelectedCustomers()
    },
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        pageLength: 25, // quantidade de registro por página
        order: [4, 'asc'], // ordena
        lengthMenu: [
          [5, 10, 25, 50, -1],
          [5, 10, 25, 50, 'Todos'],
        ], // menu para alterar a quantidade de registro
      })
    },
    countSelectedCustomers() {
      const selected = this.customers.filter((customer) => customer.isSelected)
      this.numberOfSelectedCustomers = selected.length
    },
    async insertBatchCustomers() {
      const selectedCustomers = this.customers.filter(
        (customer) => customer.isSelected,
      )
      if (selectedCustomers.length === 0) {
        this.$root.$children[0].$refs.notification.warning(
          'Nenhum cliente selecionado!',
        )
      } else {
        const accepetdCustomers = selectedCustomers.filter(
          (customer) =>
            Object.prototype.hasOwnProperty.call(customer, 'customerType') &&
            Object.prototype.hasOwnProperty.call(customer, 'classification'),
        )
        if (accepetdCustomers.length === selectedCustomers.length) {
          const response = await this.$store.dispatch('insertBatchCustomers', {
            unityId: this.unityId,
            periodId: this.periodId,
            selectedCustomers,
          })
          if (response.status) {
            this.$root.$children[0].$refs.notification.success(
              'Clientes cadastrados com sucesso!',
            )
            this.$emit('reloadCustomers')
            this.$emit('changeToSelectMode')
          } else {
            this.$root.$children[0].$refs.notification.error(
              'Erro ao cadastrar clientes!',
            )
          }
        } else {
          this.$root.$children[0].$refs.notification.warning(
            'Existem clientes que não foram preenchidos tipos e/ou classificação corretamente!',
          )
        }
      }
    },
  },

  mounted() {
    this.createDataTable()
    this.countSelectedCustomers()
  },
}
</script>
